"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IMWarehouseApiClient = void 0;
const BaseApiClient_1 = require("./BaseApiClient");
class IMWarehouseApiClient extends BaseApiClient_1.BaseApiClient {
    async editWms(request) {
        return await this.request('POST', '/v1/wms/edit', {}, request);
    }
}
exports.IMWarehouseApiClient = IMWarehouseApiClient;
